// extracted by mini-css-extract-plugin
export var parcelRow = "_ua-0";